var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-divider", { attrs: { "content-position": "left" } }, [
        _vm._v(_vm._s(_vm.$t("receivablePayable.otherRules"))),
      ]),
      _c(
        "div",
        { staticClass: "feet-r" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v(_vm._s(_vm.$t("basicData.AddAdditionalRules")))]
          ),
          _c("importAndDownloadCmp", {
            attrs: {
              "business-type": _vm.businessType,
              "subregion-list": _vm.subregionList,
              "stitching-line": _vm.stitchingLine,
              "fee-list": _vm.specialFeeList,
              "quotation-type": _vm.isQuotationMethod,
              "get-data-func": _vm.onDownloadOffer,
            },
            on: { importList: _vm.onImportList },
          }),
          _c(
            "el-popover",
            {
              attrs: { placement: "bottom-start", trigger: "hover" },
              scopedSlots: _vm._u([
                {
                  key: "reference",
                  fn: function () {
                    return [
                      _c("el-button", { attrs: { size: "small", plain: "" } }, [
                        _vm._v(_vm._s(_vm.$t("basicData.ClearTheOffer")) + " "),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "div",
                { staticClass: "feet" },
                [
                  _vm.isQuotationMethod
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.clearOffers(1)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("basicData.EmptyCurrentPartition")) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      staticClass: "feet-btn",
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.clearOffers(2)
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("basicData.EmptyAllPartitions")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      !_vm.isQuotationMethod
        ? _c("TableCmp", {
            ref: "defaultTableRef",
            attrs: {
              "fee-list": _vm.specialFeeList,
              "table-data": _vm.partitionArr,
            },
            on: { change: _vm.changeDefaultPartition },
          })
        : _c("TableCmp", {
            ref: "tableRef",
            attrs: {
              "fee-list": _vm.specialFeeList,
              "table-data": _vm.getPartitionArr,
            },
            on: { change: _vm.changePartition },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }